<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="card" id="orderList">
        <div class="card-header border-0">
          <div class="d-flex align-items-center" style="text-align: left">
            <h5 class="card-title mb-0 flex-grow-1">New Faq</h5>
          </div>
        </div>

        <div
          class="card-body border border-dashed border-end-0 border-start-0"
          style="text-align: left"
        >
          <input type="hidden" id="faq_id" v-model="faq_id" value="" />
          <div class="row g-3">
            <div class="col-lg-6">
              <div>
                <label for="faq_title" class="form-label"
                  >Question<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="faq_title"
                  v-model="faq_title"
                  class="form-control"
                  placeholder="Enter Question"
                  required
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div>
                <label for="faq_cat" class="form-label"
                  >Category<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="faq_cat"
                  v-model="faq_cat"
                  class="form-control"
                  placeholder="Enter Category"
                  required
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div>
                <label for="faq_cat1" class="form-label"
                  >For<span style="color: red">*</span></label
                >
                <select
                  class="form-control"
                  v-model="faq_cat1"
                  name="choices-single-default"
                  id="faq_cat1"
                >
                  <option value="customer" selected>Customer</option>
                  <option value="operator">Operator</option>
                </select>
              </div>
            </div>
            <div class="col-lg-12">
              <div>
                <label for="faq_ans" class="form-label"
                  >Question<span style="color: red">*</span></label
                >
                <textarea
                  id="faq_ans"
                  v-model="faq_ans"
                  class="form-control"
                  placeholder="Enter Answer"
                  required
                ></textarea>
              </div>
            </div>

            <div class="col-lg-9"></div>
            <div class="col-lg-3">
              <div
                :class="'alert alert-' + msgType + ' mb-xl-0'"
                role="alert"
                v-if="msgTxt && msgTxt.length > 0"
              >
                {{ msgTxt }}
              </div>
            </div>
            <div class="col-lg-12">
              <div class="hstack gap-2 justify-content-end">
                <button
                  type="submit"
                  v-if="faq_id.length <= 0"
                  class="btn btn-primary"
                  @click="handleSubmit()"
                >
                  Create
                </button>
                <button
                  type="submit"
                  v-if="faq_id.length > 0"
                  class="btn btn-primary"
                  @click="handleSubmit()"
                >
                  Update
                </button>
                <button type="button" class="btn btn-soft-success">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addFaq, updateFaq } from "@/apis/faqapis";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import { useInfoStore } from "@/store/info";

export default {
  name: "AddFaq",

  methods: {
    ...mapActions(useAuthStore, ["valField1"]),
    ...mapActions(useInfoStore, ["loadFaqData"]),

    async handleSubmit() {
      if (
        this.valField1(this.faq_title, "Enter Question") &&
        this.valField1(this.faq_cat, "Enter Category") &&
        this.valField1(this.faq_ans, "Enter Answer")
      ) {
        this.msgType = "warning";
        this.msgTxt = "Loading...";

        if (this.faq_id != null && this.faq_id.length > 0) {
          const response = await updateFaq(
            this.faq_id,
            this.faq_title,
            this.faq_cat,
            this.faq_cat1,
            this.faq_ans
          );

          this.msgType = response.type;
          this.msgTxt = response.message;

          if (response.status) {
            localStorage.removeItem("faq_edit_data");
            this.$router.push("/faqs");
          }
        } else {
          const response = await addFaq(
            this.faq_title,
            this.faq_cat,
            this.faq_cat1,
            this.faq_ans
          );

          this.msgType = response.type;
          this.msgTxt = response.message;

          if (response.status) {
            this.$router.push("/faqs");
          }
        }
      }
    },
  },
  data() {
    return {
      faq_id: "",
      faq_title: "",
      faq_cat: "",
      faq_cat1: "customer",
      faq_ans: "",
    };
  },

  mounted() {
    this.loadFaqData(); 

    if (this.faqData) {
      this.faq_id = this.faqData.faq_id;
      this.faq_title = this.faqData.faq_title;
      this.faq_cat = this.faqData.faq_cat;
      this.faq_cat1 = this.faqData.faq_cat1;
      this.faq_ans = this.faqData.faq_ans;
    }
  },
  computed: {
    ...mapState(useAuthStore, ["msgTxt", "msgType"]),
    ...mapState(useInfoStore, ["faqData"]),
    
  },
};
</script>

<style scoped></style>
